import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import { HeadingKindType, MediaBlock10, TextColors } from '@savebetter/components';

import { useMediaPercentageProps } from '../hooks/useMediaPercentageProps';

import { LinkProps } from './Link';
import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  title: string;
  headingKind?: HeadingKindType;
  media: MediaProps[];
  backgroundColor?: string;
  textColor?: TextColors;
  description: string;
  button: LinkProps[];
}

interface MediaSection4Props extends PageSectionProps {
  blok: Blok;
}

export const MediaSection4: FunctionComponent<React.PropsWithChildren<MediaSection4Props>> = ({
  blok,
  sectionClassName
}) => {
  const {
    hasBackground,
    hasBorder,
    title,
    headingKind,
    media = [],
    description,
    button = [],
    backgroundColor = '',
    textColor,
    hasPaddingBottom,
    hasPaddingTop
  } = blok;
  const readMore = button.length > 0 ? button[0] : null;

  const { getMediaProps } = useMediaPercentageProps();

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={classnames({
        sectionClassName,
        [backgroundColor]: !hasBackground
      })}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      {title && (
        <PageSectionHeader headingKind={headingKind} className={classnames(textColor)}>
          {title}
        </PageSectionHeader>
      )}
      <MediaBlock10 mediaProps={getMediaProps(media[0])} textColor={textColor} readMore={readMore} text={description} />
    </Section>
  );
};
